import { dom } from "../dom";

export function setStatus(text: string, isError = false): void {
  dom.statusElement.textContent = text;
  dom.statusElement.style.color = isError ? "var(--danger-strong)" : "var(--accent)";
}
